import { render, staticRenderFns } from "./modeOfPayment.vue?vue&type=template&id=2a8a3efc&"
import script from "./modeOfPayment.vue?vue&type=script&lang=js&"
export * from "./modeOfPayment.vue?vue&type=script&lang=js&"
import style0 from "./modeOfPayment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports